import React, { FC } from "react";
import { Button } from "src/components/Button";
import { ReactComponent as FavoriteIcon } from "src/assets/icons/bookmark.svg";
import { ReactComponent as FavoriteOutlineIcon } from "src/assets/icons/bookmark-outline.svg";

const MAX_FAVORITE = 99999;

interface Props {
  saved_count: number;
  isFavorite: boolean;
  addToFavorites: () => void;
  removeFromFavorites: () => void;
  isLoading?: boolean;
}

export const AddToFavoriteButton: FC<Props> = ({
  saved_count,
  isFavorite,
  addToFavorites,
  removeFromFavorites,
  isLoading,
}) => {
  const onClick = () => {
    if (isFavorite) {
      removeFromFavorites();
    } else {
      addToFavorites();
    }
  };

  const Icon = isFavorite ? FavoriteIcon : FavoriteOutlineIcon;

  const count = saved_count > MAX_FAVORITE ? `${MAX_FAVORITE}+` : saved_count;

  return (
    <div className="flex gap-1 max-w-30">
      <Button onClick={onClick} isDisabled={isLoading}>
        <Icon className="min-w-6 min-h-6" />
      </Button>
      <span className="text-lg text-purple-base">{count}</span>
    </div>
  );
};
